import * as actionTypes from "./actionTypes";
import api from "./api";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";
import { camelizeKeys } from "humps";

export function loadGlobalParams() {
  return async (dispatch, getState) => {
    let params = getState().params;
    if (params.loaded || params.loading) return;

    try {
      dispatch({ type: actionTypes.LOAD_GLOBAL_PARAMS_STARTED });
      params = await dispatch(sendHttpRequest(api.loadGlobalParams()));
      const result = {
        ...params.dynamicProperties,
        ...params
      };
      delete result.dynamicProperties;
      const camelizedJson = camelizeKeys(result);

      dispatch({ type: actionTypes.LOAD_GLOBAL_PARAMS_SUCCESS, payload: camelizedJson });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
